import React from 'react'

const CoreComponent16 = ({ content, content2 }) => {
  return (
    <div className=' ' >
      <div className='row d-flex justify-content-center mt-90 mt-md-4'>
        {
          content.map((val, i) => (
            <div key={i} className='col-lg-4 col-md-6  mb-4 pt-3' >
              <div className='me-2 border-dashed p-3 position-relative h-100 invest-box'  >
                <div className='img-abso'>
                  <img src={val.icon} alt="" className='m-0 ' />
                </div>

                <h3 className='h3-heading lh-base text-start mt-4 pt-md-2  lh-base fs-5'>{val.title}</h3>
                <p className='h3-para mt-md-2 pt-1 fs-6 lh-base'>{val.desc}</p>
              </div>

            </div>
          ))
        }
      </div>
      <div className='row mt-80 mt-md-4 mt-0'>
        {
          content2.map((val, i) => (
            <div key={i} className='col-lg-3 col-sm-6 mt-4   pt-2 '>
              <div className='me-2 border-dashed p-3 position-relative h-100  invest-box'>
                <div className='img-abso'>
                  <img src={val.icon} alt="" className='m-0 ' />
                </div>
                <h3 className='h3-heading mt-4 lh-base pt-md-2 text-start lh-base  fs-5 '>{val.title}</h3>
                <p className='mt-md-2 pt-1 fs-6 lh-base'>{val.desc}</p>
              </div>

            </div>
          ))
        }
      </div>
    </div>
  )
}

export default CoreComponent16